import * as React from 'react';

import { Button } from "../../../../../components/Buttons";
import { FormGroup } from "../../../Forms/FormGroup";
import { Polyglot } from '../../../../../polyglot';
const styles = require('./NewVehicle.local.css');

interface Props
{
    polyglot: Polyglot;
    onGeotabClicked: () => void;
    onBoxIdClicked: () => void;
    active: number;
}

export const SourceSelector: React.SFC<Props> = ({ onGeotabClicked, onBoxIdClicked, active, polyglot } :Props) => (
    <FormGroup className={styles.SourceSelectorContainer}>
        <div className="btn-group" role="group" aria-label="select a data source">
            <Button onClick={onBoxIdClicked} className={getClassName(active, 1)}>{polyglot.t('vehicle.label_box_id_source')}</Button>
        </div>
    </FormGroup>
);

function getClassName(active: number, index: number) {
    return active === index ? 'active' : null;
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Vehicle/NewVehicle/SourceSelector.tsx